enum RecensementDemande {
	BP = 'BP',
	BP_BS = 'BP_BS',
	BP_BS_DM = 'BP_BS_DM',
	JAMAIS = 'JAMAIS',
}

export default RecensementDemande;
